import { render } from "./Window.vue?vue&type=template&id=25002f80&scoped=true"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"

import "./Window.vue?vue&type=style&index=0&id=25002f80&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25002f80"]])

export default __exports__